class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.cachedResults = {};
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');

    this.setupEventListeners();
  }

  setupEventListeners() {
    const form = this.querySelector('form.search');
    form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
    this.input.addEventListener('focus', this.onFocus.bind(this));

    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));

    // 打点
    this.predictiveSearchResults.addEventListener('click', (e) => {
      wltProductClick(e, { pageId: '14' })
    }, false);
    this.closest('details-modal') && this.closest('details-modal').addEventListener('detailsModalOpened', e => {
      TrackerLog('pageview', '14')
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.close(true);
      return;
    }

    this.getSearchResults(searchTerm);
    TrackerLog('', '', {
      channel_ids: '11',
      emarsys: ['searchTerm', searchTerm]
    })
  }

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) return;

    if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault();
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');
    const allElements = this.querySelectorAll('li');
    let activeElement = this.querySelector('li');

    if (moveUp && !selectedElement) return;

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0];
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
    }

    if (activeElement === selectedElement) return;

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.setLiveRegionText(activeElement.textContent);
    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

    if (selectedProduct) selectedProduct.click();
  }

  _productExpose() {
    let products = [].slice.call(this.predictiveSearchResults.querySelectorAll('.wholee-prod__js'));
    if ("IntersectionObserver" in window) {
      let wholeeProdObserver = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            let element = entry.target;
            productTrackerEvent('product', element, '14')
            element.classList.remove('wholee-prod__js');
            wholeeProdObserver.unobserve(element);
          }
        });
      });
      products.forEach(function(ele) { wholeeProdObserver.observe(ele) });
    }
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    const queryData = {
      pageNo: 1,
      pageSize: 4,
      searchContent: searchTerm,
      clientBasic: JSON.stringify(clientBasic)
    }
    fetch(routes.predictive_search_url + formatXHRParams(queryData), {credentials: 'include'})
      .then(response => response.json())
      .then(data => {
        if (data.code === 0) {
          let results = data.body.cards;
          if (results && results.length > 0) {
            results = results.map((ele, index) => {
              ele.cardSpu['pos'] = index + 1;
              ele.cardSpu['pvid'] = data.body.pvid;
              return ele
            })
          }
          const resultsMarkup = this.getResultsHTML(results, searchTerm);
          this.cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          this._productExpose();
        }
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  getResultOptionHTML (data, index) {
    const { url, title, priceMin, priceMax, images } = data
    const p_price = Number(priceMin) !== Number(priceMax) ? `${formatAmount(currency_symbol, priceMin)} - ${formatAmount(currency_symbol, priceMax)}` : formatAmount(currency_symbol, priceMin);
    const href = url + '?' + prodHrefQuery(data);

    return `<li id="predictive-search-option-${index}" class="predictive-search__list-item wholee-prod__js" role="option" aria-selected="false" data-report="${dataReportTpl(data)}">
      <a href="${href}" class="predictive-search__item predictive-search__item--link link link--text wlt" tabindex="-1">
        <img class="predictive-search__image" src="${images[0]}" alt="${title}"  width="50" height="50">
        <div class="predictive-search__item-content">
          <h3 class="predictive-search__item-heading h5">${title}</h3>
          <div class="price">${p_price}</div>
        </div>
      </a>
    </li>`
  }

  getResultsHTML (data, query) {
    const options = data.length > 0 ? data.reduce((prev, cur, index) => {
      return prev + this.getResultOptionHTML(cur.cardSpu, index + 1)
    }, '') : ''
    return `<div id="predictive-search-results">${data.length > 0 ?
      `<h2 id="predictive-search-products" class="predictive-search__heading">Products
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>
      </h2>` : ''}
      <ul id="predictive-search-results-list" class="predictive-search__results-list list-unstyled" role="listbox" aria-labelledby="predictive-search-products">${options}
        <li id="predictive-search-option-search-keywords" class="predictive-search__list-item" role="option">
          <button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1">Search for "${query}"
            <svg viewBox="0 0 14 10" fill="none" aria-hidden="true" focusable="false" role="presentation" class="icon icon-arrow" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537.808a.5.5 0 01.817-.162l4 4a.5.5 0 010 .708l-4 4a.5.5 0 11-.708-.708L11.793 5.5H1a.5.5 0 010-1h10.793L8.646 1.354a.5.5 0 01-.109-.546z" fill="currentColor"></svg>
          </button>
        </li>
      </ul>
      <div class="predictive-search__loading-state" aria-hidden="true">
        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg>
      </div>
    </div>
    <span class="hidden" data-predictive-search-live-region-count-value>${data.length} results found for "${query}"</span>`
  }

  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;
    this.setAttribute('results', true);

    this.setLiveRegionResults();
    this.open();
  }

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
  }

  close(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }

    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);
